import { Link } from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";

export const purchaseGiftCardLanguages = {
  navMenueLinkText: "Purchase Deposit",
  pageTitle: "Winnipeg Jets Deposit",
  mainCardTitle: "Purchase Deposit",
  amountTitle: "Deposit Amount",
  checkoutCardTitle: "Purchase Deposit",
  checkoutItemTitle: "Deposit Amount",
};

export const purchaseSeatsLanguages = {
  purchaseSeatTabTitle: "Create Game Pack",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description:
      "Click Continue & connect your Winnipeg Jets account account using our select Ticketmaster login.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available by logging into your{" "}
        <Link
          href={"https://am.ticketmaster.com/tnse/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          TN Central Account Manager
        </Link>
        . Reach out to{" "}
        <Link
          href={"mailto:ticketsales@winnipegjets.com"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          ticketsales@winnipegjets.com
        </Link>{" "}
        for any questions
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How do Winnipeg Jets Game Packs work?",
    description:
      "Winnipeg Jets Game Packs allow fans to select games from each of the 4 tiers. The more games in your Game Pack, the more variety you have for your customization.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Game Pack purchasers have access to select inventory in the Upper Bowl for all Winnipeg Jets regular season home games.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your TN Ticket Central
        Account Manager at{" "}
        <Link
          href={"https://am.ticketmaster.com/tnse/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          https://am.ticketmaster.com/tnse/
        </Link>
        .
      </>
    ),
  },
  {
    title: "My tickets are not available once I arrive at the checkout.",
    description:
      "There are some instances where multiple games select the same ticket and attempt to checkout at the same time. Unfortunately, this will cause one fan to check out with tickets that are no longer available for purchase and will require the fan to select a different seat. To avoid this scenario, please check out with one seat selection at a time during peak demand windows, including initial game selection and immediately prior to game start. ",
  },
];

export const WinnipegJetsFlexCheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const WinnipegJetsFlexRegistrationTerms = () => (
  <>
    By creating an account you agree to receive email notifications regarding
    your purchase and to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);
